import React, { useState, useEffect } from 'react';
import './AddressModal.css';
import Modal from './common/Modal';

const AddressModal = ({ isOpen, onClose, onSave, address }) => {
  const [formData, setFormData] = useState({
    city: '',
    street: '',
    building: '',
    apartment: ''
  });

  useEffect(() => {
    if (address) {
      setFormData({
        city: address.city || '',
        street: address.street || '',
        building: address.building || '',
        apartment: address.apartment || ''
      });
    } else {
      setFormData({
        city: '',
        street: '',
        building: '',
        apartment: ''
      });
    }
  }, [address, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} overlayClassName="modal-overlay" contentClassName="modal-content">
      <div className="modal-header">
        <h2>{address ? 'Редактировать адрес' : 'Новый адрес'}</h2>
        <button className="close-button" onClick={onClose}>×</button>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="city">Город *</label>
          <input
            type="text"
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
            placeholder=""
          />
        </div>
        <div className="form-group">
          <label htmlFor="street">Улица *</label>
          <input
            type="text"
            id="street"
            name="street"
            value={formData.street}
            onChange={handleChange}
            required
            placeholder=""
          />
        </div>
        <div className="form-group">
          <label htmlFor="building">Дом *</label>
          <input
            type="text"
            id="building"
            name="building"
            value={formData.building}
            onChange={handleChange}
            required
            placeholder=""
          />
        </div>
        <div className="form-group">
          <label htmlFor="apartment">Квартира</label>
          <input
            type="text"
            id="apartment"
            name="apartment"
            value={formData.apartment}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <div className="modal-actions">
          <button type="button" className="button-secondary" onClick={onClose}>
            Отмена
          </button>
          <button type="submit" className="button-primary">
            {address ? 'Сохранить' : 'Создать'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddressModal;
